const notificationUserState = {
    errorNotificationUser: false,
    messageErrorNotificationUser: '',
    successNotificationUser: false,
    messageSuccessNotificationUser:'',
}
const notificationUser = (state = notificationUserState, action) => {
    switch (action.type) {
        case 'updateErrorNotiUser':
            return { ...state, errorNotificationUser: action.item.error, messageErrorNotificationUser: action.item.message }
        case 'updateSuccessNotiUser':
            return { ...state, successNotificationUser: action.item.success, messageSuccessNotificationUser: action.item.message }
        default:
            return state
    }
}

export default notificationUser;